/* global FB */

import React, { PropTypes, Component } from 'react'
import moment from 'moment-timezone'

import './FacebookLoginButton.scss'
import { TIMEZONE } from '@src/globals'

class FacebookLoginButton extends Component {
  constructor () {
    super()
    this.state = {
      fbLoaded: typeof FB !== 'undefined'
    }
    this.onStatusChange = this.onStatusChange.bind(this)
    this.checkSDKStatus = this.checkSDKStatus.bind(this)
  }

  componentDidMount () {
    this.interval = setInterval(this.checkSDKStatus, 100)
  }

  checkSDKStatus () {
    if (typeof FB !== 'undefined') {
      clearInterval(this.interval)
      delete this.interval
      FB.Event.subscribe('auth.statusChange', this.onStatusChange)
      this.setState({fbLoaded: true})
      setTimeout(FB.XFBML.parse, 100)
    }
  }

  onStatusChange (response) {
    const { authResponse } = response
    const { callback } = this.props

    if (authResponse) {
      const payload = {
        uid: authResponse.userID,
        token: authResponse.accessToken,
        expiresAt: moment().tz(TIMEZONE).add(authResponse.expiresIn, 'seconds').format()
      }
      callback(payload)
    }
  }

  render () {
    const { authenticating } = this.props
    const { fbLoaded } = this.state
    const loading = !fbLoaded || authenticating
    return (
      <div className='FacebookLoginButton'>
        {
          loading
          ? (
            <p className='FacebookLoginButton-loader'><span className='icon-spinner icon-spin' /> Cargando</p>
          )
          : (
            <div
              className='fb-login-button'
              data-size='large'
              data-use-continue-as='true'
              data-scope='public_profile, email'
            />
          )
        }
      </div>
    )
  }
}

FacebookLoginButton.displayName = 'FacebookLoginButton'
FacebookLoginButton.propTypes = {
  callback: PropTypes.func.isRequired,
  authenticating: PropTypes.bool
}
FacebookLoginButton.defaultProps = {
  authenticating: false
}

export default FacebookLoginButton



// WEBPACK FOOTER //
// ./src/screens/App/shared/components/FacebookLoginButton/FacebookLoginButton.js